t = require('views/internal/teacup-with-helpers')('card_detail_watch_menu')

module.exports = t.renderable ({ signupUrl, loginUrl }) ->
  t.div '.signup-on-watch-content', ->
    t.span '.top-text', ->
      t.format 'sign-up-to-watch-this-card'
    t.a '.js-sign-up-on-watch-menu.button-link.highlight', { href: signupUrl }, ->
      t.span -> t.format 'sign-up'
    t.hr()
    t.div '.bottom-text', ->
      t.span -> t.format 'already-have-an-account'
      t.span ' '
      t.a '.js-log-in-on-watch-menu.log-in-link', { href: loginUrl }, -> t.format 'log-in'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_watch_menu.coffee